import React, { useState } from 'react';

import dropDownBoldGreyIcon from '../../../../../../assets/img/dropdown-arrow-bold-grey.svg';

import styles from './Toolbar.module.css';

const IframeToolbar = props => {
  const { campaignId, blockId, onExportIncompleteQuestionResponses } = props;

  const [toolbarActive, setToolbarActive] = useState(false);

  return (
    <>
      <div
        className={`${styles.container} ${
          toolbarActive ? styles.containerActive : ''
        }`}
      >
        <div
          className={`${styles.toolbarItem} ${styles.clickable}`}
          role="presentation"
          onClick={() => {
            if (campaignId && blockId) {
              onExportIncompleteQuestionResponses(campaignId, blockId);
            }
          }}
        >
          Export Useberry responses that didn’t complete the survey
        </div>
      </div>
      <div />
      <img
        src={dropDownBoldGreyIcon}
        alt="Display toolbar"
        className={`${styles.dropDownToolbarIcon} ${
          !toolbarActive ? styles.dropDownToolbarIconInactive : ''
        }`}
        role="presentation"
        onClick={() => {
          setToolbarActive(!toolbarActive);
        }}
      />
    </>
  );
};

export default IframeToolbar;
